import React from 'react';

import { Stack } from '@eluve/components';

import { TabEmptyState } from './TabEmptyState';

/**
 * Overview-tab shell. Cards are composed in by the router (children) rather
 * than imported here — the FHIR feature libs consume `@eluve/fhir-data`,
 * which depends on this lib, so importing them from here would cycle.
 */
export const PatientOverviewTab: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  if (!children) {
    return (
      <TabEmptyState
        title="Overview"
        description="The patient's medical information will live here."
      />
    );
  }
  return (
    <Stack gap={6} align="stretch">
      {children}
    </Stack>
  );
};
